export default "__VITE_ASSET__BrHuqtfD__"